<!--
 * @Author: DY
 * @Date: 2024-12-14 11:55:04
 * @LastEditTime: 2025-04-15 16:02:23
 * @Description: 二次检测列表
 * @FilePath: \ShiMo_Mobile\src\views\purchase\secondaryTesting\index.vue
-->
<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="secondaryTesting commonListStyles">
            <van-nav-bar
                left-arrow
                title="二次检测"
                :style="`height: ${ $getNavHeight() }px;`"
                @click-left="swiperright"
            ></van-nav-bar>
            <section>
                <van-search v-model="keyVal" placeholder="请输入搜索信息" @change="onRefresh"></van-search>
                <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
                    <van-list
                        v-model="isUpLoading"
                        finished-text="没有更多了!"
                        :finished="finished"
                        @load="onLoad"
                    >
                        <ul class="list">
                            <li class="listItem" v-for="(item,index) in listData" :key="`item_${index}`">
                                <div class="engineeringInfo">
                                    <h4 class="itemTitle">
                                        <span class="iconfont iconhetong">二次检测编号：{{ item.quality_number }}</span>
                                    </h4>
                                    <p class="itemStatus">
                                        {{ item.status_name }}
                                    </p>
                                    <div class="itemContent">
                                        <p>
                                            <img src="@/assets/images/icons/icon_28@2x.png" alt="">
                                            <span>汽运单编号：{{ item.ysd_number }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_32@2x.png" alt="">
                                            <span>物料：{{ item.material_type }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_10@2x.png" alt="">
                                            <span>长描述：{{ item.material_name }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_28@2x.png" alt="">
                                            <span>短描述：{{ item.material_short_name }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_24@2x.png" alt="">
                                            <span>单位：{{ item.unit }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_1@2x.png" alt="">
                                            <span>到场数量：{{ item.into_count }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_1@2x.png" alt="">
                                            <span>一次签收数据量：{{ item.sign_count1 }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_10@2x.png" alt="">
                                            <span>外观检测意见：{{ item.appearance_detection }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_29@2x.png" alt="">
                                            <span>需求部门：{{ item.apply_dept_name }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_8@2x.png" alt="">
                                            <span>需求部门联系人：{{ item.apply_user_name }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_7@2x.png" alt="">
                                            <span>到场时间：{{ item.into_time }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_7@2x.png" alt="">
                                            <span>核对时间：{{ item.check_time1 }}</span>
                                        </p>
                                    </div>
                                    <div class="itemBtn itemBtns">
                                        <template v-if="item.is_view === 0">
                                            <button @click="openRegisterFrom('edit', item)">
                                                编辑
                                            </button>
                                        </template>
                                        <button v-else @click="openRegisterFrom('see', item)">
                                            查看
                                        </button>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </van-list>
                </van-pull-refresh>
            </section>
        </div>
    </v-touch>
</template>

<script>
import { mixin_list } from '@/assets/mixin/mixin_list';
export default {
    name: 'secondary-testing',
    mixins: [mixin_list],
    beforeRouteLeave(to, from, next) {
        if (to.path === '/home') {
            this.$store.commit('noKeepAlive', 'secondary-testing');
        }
        next();
    },
    data() {
        return {
            tableCode: 'cg_ysd_ecjc',
        };
    },
    filters: {},
    computed: {},
    watch: {},
    activated() {
        if (this.$route.params.saveCallback) {
            this.onRefresh();
        }
    },
    created() {
        this.cacheKey = Math.floor(Math.random() * 1000000000000 + 1);
    },
    mounted() {},
    methods: {
        // 查看登记表
        openRegisterFrom(type, data) {
            this.$router.isBack = 2;
            this.$router.push({
                name: 'secondaryTestingForm',
                params: {
                    type,
                    data,
                },
            });
        },

    },
};
</script>
<style lang="stylus"></style>
